var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiangbei2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_427)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_20_427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 9.99998C0.833496 11.2038 1.0706 12.3958 1.53127 13.5079C1.99194 14.6201 2.66715 15.6306 3.51835 16.4818C4.36955 17.333 5.38008 18.0082 6.49223 18.4689C7.60438 18.9295 8.79638 19.1666 10.0002 19.1666C11.2039 19.1666 12.3959 18.9295 13.5081 18.4689C14.6202 18.0082 15.6308 17.333 16.482 16.4818C17.3332 15.6306 18.0084 14.6201 18.4691 13.5079C18.9297 12.3958 19.1668 11.2038 19.1668 9.99998C19.1668 7.56883 18.2011 5.23725 16.482 3.51817C14.7629 1.79908 12.4313 0.833313 10.0002 0.833313C7.56901 0.833313 5.23743 1.79908 3.51835 3.51817C1.79927 5.23725 0.833496 7.56883 0.833496 9.99998Z",
    fill: "white",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.13667 12.5L9.16667 15.53L5.53 19.1667L4.77167 16.895L2.5 16.1367L6.13667 12.5ZM13.8633 12.5L17.5 16.1367L15.2283 16.895L14.47 19.1667L10.8333 15.53L13.8633 12.5Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 2.14748L16.3832 5.35165C16.6366 5.49792 16.847 5.70831 16.9932 5.96167C17.1395 6.21503 17.2165 6.50242 17.2165 6.79498V13.2041C17.2165 13.8 16.899 14.35 16.3832 14.6475L10.8332 17.8525C10.5798 17.9987 10.2924 18.0756 9.99987 18.0756C9.70733 18.0756 9.41993 17.9987 9.16654 17.8525L3.61654 14.6483C3.36318 14.502 3.15278 14.2916 3.0065 14.0383C2.86022 13.7849 2.78321 13.4975 2.7832 13.205V6.79581C2.7832 6.19998 3.1007 5.64998 3.61654 5.35248L9.16654 2.14748C9.41993 2.00128 9.70733 1.92432 9.99987 1.92432C10.2924 1.92432 10.5798 2.00128 10.8332 2.14748Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0806 8.95752L11.0681 8.94169L13.6714 4.38085L12.0431 3.34752L9.99977 8.33419L7.93311 3.29169L6.32561 4.37669L8.93144 8.94169L8.91894 8.95752L3.19811 7.24002L3.18311 9.26002L8.60394 10.1459L8.61561 10.1967L3.45477 13.8484L5.04394 15.1617L9.38727 11.1509L8.9756 17.5H11.0231L10.6106 11.1517L14.9156 15.1267L16.5439 13.8492L11.3831 10.1975L11.3948 10.1467L16.7889 9.26502L16.7206 7.26502L11.0806 8.95752Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 6.66669H12.5V10H10.8333V6.66669ZM7.5 9.16669H9.16667V12.5H7.5V9.16669Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.66669V8.33335H7.5V6.66669H12.5ZM12.5 11.6667V13.3334H7.5V11.6667H12.5ZM12.5 9.16669V10.8334H7.5V9.16669H12.5Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 2.86915C10.2899 2.79584 10.1462 2.75724 9.99987 2.75724C9.85356 2.75724 9.70983 2.79584 9.5832 2.86915L4.0332 6.07415C3.7757 6.22331 3.61654 6.49831 3.61654 6.79581V13.205C3.61654 13.5025 3.7757 13.7775 4.0332 13.9266L9.5832 17.1308C9.70983 17.2041 9.85356 17.2427 9.99987 17.2427C10.1462 17.2427 10.2899 17.2041 10.4165 17.1308L15.9665 13.9266C16.224 13.7775 16.3832 13.5025 16.3832 13.205V6.79581C16.3832 6.49831 16.224 6.22331 15.9665 6.07415L10.4165 2.86915ZM10.8332 2.14748L16.3832 5.35165C16.6366 5.49792 16.847 5.70831 16.9932 5.96167C17.1395 6.21503 17.2165 6.50242 17.2165 6.79498V13.2041C17.2165 13.8 16.899 14.35 16.3832 14.6475L10.8332 17.8525C10.5798 17.9987 10.2924 18.0756 9.99987 18.0756C9.70733 18.0756 9.41993 17.9987 9.16654 17.8525L3.61654 14.6483C3.36318 14.502 3.15278 14.2916 3.0065 14.0383C2.86022 13.7849 2.78321 13.4975 2.7832 13.205V6.79581C2.7832 6.19998 3.1007 5.64998 3.61654 5.35248L9.16654 2.14748C9.41993 2.00128 9.70733 1.92432 9.99987 1.92432C10.2924 1.92432 10.5798 2.00128 10.8332 2.14748Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_20_427",
    x: -3.1665,
    y: -3.16669,
    width: 26.3335,
    height: 26.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_20_427"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_20_427",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_20_427"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_20_427",
    result: "effect3_innerShadow_20_427"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiangbei2);
export default __webpack_public_path__ + "static/media/jiangbei2.cb5c605344bccaf775c327220ca545c3.svg";
export { ForwardRef as ReactComponent };